export default __webpack_public_path__ + "static/media/tramy_login_wallpaper.dc163b2d.svg";